import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CookieService} from 'ngx-cookie-service';
import {routePath} from 'sdv-common';
import {ApiService} from '../../service/api.service';
import {PermissionService} from '../../service/permission.service';
import {UserTypeService} from '../../service/user-type.service';
import {keys, redirect, reload} from '../../shared/constants';

@Component({
  selector: 'add-project',
  templateUrl: './add-project.component.html',
  styleUrls: ['./add-project.component.scss']
})
export class AddProjectComponent implements OnInit {

  error = '';
  loading = false;
  submitted = false;
  formGroup: FormGroup;

  constructor(private apiService: ApiService,
              private formBuilder: FormBuilder,
              private userTypeService: UserTypeService,
              private permissionService: PermissionService,
              private cookieService: CookieService) {
  }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      name: ['', Validators.required],
      description: ['', Validators.required]
    });
  }

  get fg() {
    return this.formGroup.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.formGroup.invalid) {
      return;
    }
    this.loading = true;

    let _this = this;
    this.apiService.send({
      command: 'create_project',
      request: {
        name: this.fg.name.value,
        description: this.fg.description.value
      }
    }, (response, headers) => {
      response = response.response;
      if (!response.error) {
        _this.cookieService.set(keys.project, response.id);
        reload('/alarms');
        return;
      }

      _this.fg.name.enable();
      _this.fg.description.enable();
      _this.error = response.error.message;
      _this.loading = false;
    });
  }
}
